import PropTypes from "prop-types";
import { useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Drawer,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MenuList from "./components/MenuList/MenuList";

import FIVBLogo from "assets/images/icons/fivb-logo-sidemenu.svg";
import ProfileSection from "../ProfileSection/ProfileSection";
import RedirectModal from "components/RedirectModal/RedirectModal";
import "assets/styles.css";

// ==============================|| INFO ICON ||============================== //

const InfoIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10.1" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M12 6.6V13"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16.8" r="1.15" fill="currentColor" />
  </svg>
);

const drawerWidth = "20%";
const MinSideBar = `/icons/keyboard_tab_rtl.svg`;

const ExpandSideBar = `/icons/keyboard_tab_rtl_expand.svg`;

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, handleLeftDrawerToggle, menuItems }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const minimizedWidth = 80;
  const [infoOpen, setInfoOpen] = useState(false);

  const drawer = (
    <PerfectScrollbar
      component="div"
      style={{
        height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
        paddingLeft: "13px",
        paddingRight: "13px",
      }}
    >
      <div className={drawerOpen ? "SideBarDrawerScroll" : "SideBarDrawerMinimizedScroll"}>
        <img
          style={{ width: "64px", height: "23px" }}
          src={FIVBLogo}
          alt={"FIVB Logo"}
        />
        <button
          onClick={handleLeftDrawerToggle}
          style={{ border: "none", background: "none", padding: "0" }}
        >
          <img
            style={{ width: "24px", height: "24px", cursor: "pointer" }}
            src={drawerOpen ? MinSideBar : ExpandSideBar}
            alt={drawerOpen ? "Minimize Sidebar" : "Expand Sidebar"}
          />
        </button>
      </div>

      <MenuList isMinimized={!drawerOpen} menuItems={menuItems} />
      <ListItemButton
        className="NavItemButton"
        onClick={() => setInfoOpen(true)}
        selected={infoOpen}
        sx={{
          padding: !drawerOpen ? "8px 16px" : "4px 16px",
          mb: !drawerOpen ? "16px" : "14px",
          color: "#d3d2e3",
          justifyContent: !drawerOpen ? "center" : "flex-start",
        }}
      >
        <ListItemIcon
          sx={{
            my: "auto",
            minWidth: !drawerOpen ? "auto" : 36,
            color: "#d3d2e3",
          }}
        >
          <InfoIcon />
        </ListItemIcon>
        {drawerOpen && (
          <ListItemText
            primary={
              <Typography color="inherit" className="NavItemTypo">
                SUBMIT FEEDBACK
              </Typography>
            }
          />
        )}
      </ListItemButton>
      <Divider
        sx={{
          mt: 0.25,
          mb: 1.25,
          color: "var(--custom-accent-7, #E3E7E9)",
        }}
      />
      <ProfileSection isMinimized={!drawerOpen} />
      <RedirectModal open={infoOpen} onClose={() => setInfoOpen(false)} />
    </PerfectScrollbar>
  );


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: drawerOpen ? drawerWidth : minimizedWidth,
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        variant="permanent"
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidth : minimizedWidth,
            background: "var(--custom-accent-1, #261E7F)",
            color: theme.palette.text.primary,
            borderRight: "none",
            paddingTop: matchUpMd ? "48px" : "48px",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,

  window: PropTypes.object,
};

export default Sidebar;
